import React from 'react';
import { useLocalizedData } from '../hooks/useTranslatedContent';

function SecondBanner({ aboutData }) {
    const { getLocalizedFirstItem } = useLocalizedData(aboutData);

    if (!aboutData) return null;

    const bannerItem = getLocalizedFirstItem('secondBanner');
    const backgroundImage = bannerItem?.img || '/default-banner.jpg';

    return (
        <section
            id="home"
            className="py-36 lg:py-56 w-full table relative h-[799px] bg-no-repeat"
            style={{
                backgroundImage: `url("${backgroundImage}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
            }}
        >
            <div className="absolute inset-0 bg-black/20"></div>

            {!bannerItem?.img && (
                <div className="absolute inset-0 flex items-center justify-center">
                </div>
            )}
        </section>
    );
}

export default SecondBanner;